import FormGroupElement from "./FormGroupElement";
import React from "react";

class Checkbox extends FormGroupElement {

    render() {
        return (
            <div className="form-check">
                <input {...this.prepareProps()}/>
                {this.createLabel()}
                {this.createHelp()}
            </div>
        );
    }

    protected createLabel() {
        const className = 'form-check-label' + (this.props?.required ? ' required' : '');
        return (
            <label htmlFor={this.props.id} className={className}>{
                this.props.labelText || this.dictionary.get[this.props.label || this.props.id]
            }</label>
        );
    }

    protected prepareProps(): {} | any {
        let props = super.prepareProps();

        props.type = "checkbox";
        props.className = "form-check-input";

        return props;
    }
}

export default Checkbox;
